import ReducerCreator from '../registerReducer';
import { buildStoreItem, copyStoreItem } from '../storeItemBuilder';
import * as USERS from './users.constants';
import { ApplicationUserViewModel } from '../../models';
import { StoreItem } from '../Store';
import { APPLICATION_DISCONNECTED } from '../application/application.constants';

const r = new ReducerCreator<ApplicationUserViewModel>()
    .register<any>(USERS.USERS_LOAD_ERROR, (state, reason) => {
        return {
            dictionary: {},
            isLoading: false,
            isLoaded: false,
            hasError: true,
            error: reason.data.Message || reason.message
        };
    })
    .register<ApplicationUserViewModel[]>(USERS.USERS_LOAD, (state, payload) => {
        const res = copyStoreItem(state.dictionary);
        res.isLoading = true;
        res.isLoaded = false;
        return res;
    })
    .register<ApplicationUserViewModel[]>(USERS.USERS_LOAD_SUCCESS, (state, payload) => {
        return buildStoreItem(payload);
    })
    .register<ApplicationUserViewModel>(APPLICATION_DISCONNECTED, (state, payload) => {
        return new StoreItem<ApplicationUserViewModel>();
    })
    ;

export function usersReducer(state: StoreItem<ApplicationUserViewModel> = new StoreItem<ApplicationUserViewModel>(), action: { type: string, payload: any }) {
    return r.reduce(state, action);
}